<template>
    <div @mouseup.prevent="mousedown">
        <ul class="pl-0">
            <v-treeview-item class="v-treeview-item" v-for="item in value" :key="item.id"
                             :model="item" :treeTypes="treeTypes" :openAll="openAll" :openNode="openNode" :openByType="openByType" :searchText="searchText"
                             @selected="selected" @openTree="openTree">
                <template v-slot:prepand="{item}">
                    <slot name="prepand" :item="item" />
                </template>
            </v-treeview-item>
        </ul>
        <v-context :show="showContext" :contextItems="contextItems" :mouseEvent="mouseEvent" @contextSelected="contextSelected"></v-context>
    </div>
</template>

<script>
import VTreeviewItem from './CustomTreeviewItem.vue'
import VContext from './CustomContext.vue'

export default {
  props: [
    'value',
    'treeTypes',
    'openNode',
    'openAll',
    'contextItems',
    'editName',
    'openByType',
    'searchText'
  ],
  name: 'v-treeview',
  data() {
    return {
      showContext: false,
      mouseEvent: null
    }
  },
  created() {},
  methods: {
    selected(node) {
      this.$emit('selected', node)
    },
    contextSelected(title) {
      this.$emit('contextSelected', title)
    },
    openTree(node) {
      this.$emit('openTree', node)
    },
    mousedown(e) {
      if (this.contextItems) {
        e.preventDefault()
        this.mouseEvent = {
          button: e.button,
          pageX: e.layerX,
          pageY: e.layerY
        }
      }
    }
  },
  components: {
    VContext,
    VTreeviewItem
  }
}
</script>

<style scoped>
    ul {
        position: relative;
    }
</style>





// WEBPACK FOOTER //
// src/views/CustomTreeView/CustomTreeview.vue